import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  Fade,
  IconButton,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import api from "../../../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { GridCloseIcon } from "@mui/x-data-grid";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import GncJsonDialog from "../GncJsonDialog";

export interface KmTransData{
  idx : number;
  crw_idx : number;
  topic_cd : string;
  data_type_cd : string;
  created_date : string;
  seq : string;
  mgm_pk : string;
  issue_date : string;
  writer_ko : string;
  writer_km : string;
  copyrighter_ko : string;
  copyrighter_km : string;
  org_ext : string;
  data_src : string;

  url: string;
  kwd_km: string;
  kwd_ko: string;
  kwd_en: string;
  title_km: string;
  title_ko: string;
  title_en: string;
  text_km: string;
  text_ko: string;
  text_en: string;

  wrd_cnt : string;
  file_size : string;
  
  prc_json : string;
  prc_yn : string;
  prc_date : string;
  
  isp1_user : string;
  isp1_yn : string;
  isp1_date : string;
  isp1_rsn : string;
  isp1_rsn_cd : string;
  
  isp2_user : string;
  isp2_yn : string;
  isp2_date : string;
  isp2_rsn : string;
  
  ins_date : string;

  instruction_yn : string;
}

export interface DetailCat{
  idx: number;
  crw_idx: number;
  
  kwd_km: string;
  kwd_ko: string;
  kwd_en: string;
}

export interface DetailCrw{
  idx: number;
  site_name: string;
  url: string;
  title_km: string;
  text_km: string;
}

// const initailCatDetailData: DetailCat = {
//   idx: -1,
//   crw_idx: -1,
  
//   kwd_km: "",
//   kwd_ko: "",
//   kwd_en: "",
// }


const initailKmTransData: KmTransData = {
  idx : -1,
  crw_idx : -1,
  topic_cd : "",
  data_type_cd : "",
  created_date : "",
  seq : "",
  mgm_pk : "",
  issue_date : "",
  writer_ko : "",
  writer_km : "",
  copyrighter_ko : "",
  copyrighter_km : "",
  org_ext : "",
  data_src : "",

  url: "",
  kwd_km: "",
  kwd_ko: "",
  kwd_en: "",
  title_km: "",
  title_ko: "",
  title_en: "",
  text_km: "",
  text_ko: "",
  text_en: "",

  wrd_cnt : "",
  file_size : "",
  
  prc_json : "",
  prc_yn : "",
  prc_date : "",
  
  isp1_user : "",
  isp1_yn : "",
  isp1_date : "",
  isp1_rsn : "",
  isp1_rsn_cd : "",
  
  isp2_user : "",
  isp2_yn : "",
  isp2_date : "",
  isp2_rsn : "",
  
  ins_date : "",
  instruction_yn: "",
};

// const initailCrwDetailData: DetailCrw = {
//   idx: -1,
//   site_name: "",
//   url: "",
//   title_km: "",
//   text_km: "",

// };

// const initailTrsDetailData: DetailTrans = {
//   idx: -1,
//   crw_idx: -1,
//   title_ko: "",
//   text_ko: "",
//   title_en: "",
//   text_en: "",
//   ins_date: "",

// };

const KhmISPTransDialog = (props: any) => {

  // const [data, setData] = useState<KmTransData>(initailKmTransData);

  const [openJsonDialog, setOpenJsonDialog] = useState<boolean>(false)

  const [prc_data, setPrc_data] = useState<KmTransData>(initailKmTransData);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [open_pop, setOpen_pop] = useState(false);
  const [placement, setPlacement] = useState<PopperPlacementType>();

  const handleClick =
    (newPlacement: PopperPlacementType) =>
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      setOpen_pop((prev) => placement !== newPlacement || !prev);
      setPlacement(newPlacement);
    };

  // const [catDetail, setCatDetail] = useState<DetailCat>(initailCatDetailData);

  // const [crwDetail, setCrwDetail] = useState<DetailCrw>(initailCrwDetailData);

  // const [trsDetail, setTrsDetail] = useState<DetailTrans>(initailTrsDetailData);

  // const [check_instruction, setCheck_instruction] = useState<boolean>(false);

  const [l_select, setL_select] = useState("KM")

  const [m_select, setM_select] = useState("KO")

  const [r_select, setR_select] = useState("EN")

  const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  // let manager_role = auth.user.roles.some((obj:any) => ['VIE_MANAGER'].includes(obj.role));

  const getAuths = async () => {
    var result = await api.get("/getAuths");
    setAuths(result.data.data);
  };

  const getPrcDetail = async (idx: number) => {
    var result = await api.get("/km-prc-detail",{params:{email:email,idx:idx}});
    setPrc_data(result.data.datas[0])
  };

  // const getCatDetail = async (idx: number) => {
  //   var result = await api.get("/km-cat-detail",{params:{idx:idx}});
  //   setCatDetail(result.data.datas[0])
  // };

  // const getCrwDetail = async (idx: number) => {
  //   var result = await api.get("/km-crw-detail",{params:{idx:idx}});
  //   setCrwDetail(result.data.datas[0])
  // };

  // const getTrsDetail = async (idx: number) => {
  //   var result = await api.get("/km-detail",{params:{idx:idx}});
  //   setTrsDetail(result.data.datas[0])
  // };

  const updateInstructionYn = async (v: boolean) => {

    const formData = new FormData();

    formData.append("email", email);

    formData.append("idx", prc_data.idx.toString());

    formData.append("instruction_yn", (v == true ? "Y" : "N"));

    let alert_message = (v == true ? "Instruction 대상 설정 완료" : "Instruction 대상 해제 완료")

    await api.post("/km-instruction-update",formData)
    .then((res:any) => { alert(alert_message); setPrc_data({ ...prc_data, instruction_yn: res.data }) })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})
  }

  const saveIsp1Data = async (isp1_yn:string) => {

    if(prc_data.isp1_rsn_cd == "None" && isp1_yn == "N"){
      alert('부적합 처리에 따른 부적합코드를 선택하세요. ')
      return;
    }

    if(prc_data.isp1_rsn_cd == "09" && (prc_data.isp1_rsn == "None" || prc_data.isp1_rsn == "")){
      alert('직접입력에 따른 검수비고를 작성하세요(09.직접입력 필수)')
      return;
    }

    const formData = new FormData();

    formData.append("email", email);

    formData.append("isp1_yn", isp1_yn);

    formData.append("datas", JSON.stringify(prc_data));

    // formData.append("trs_datas", JSON.stringify(trsDetail));

    await api.post("/km-isp-update",formData)
    .then((res:any) => { alert("업데이트가 완료되었습니다."); props.getKmList(props.p_order, props.prc_yn, props.isp_yn, props.p_instruction_yn, props.p_worker, props.p_topic_cd); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }


  useEffect(() => {
    getAuths();
    // setData(initailData);
    // setData(props.rowDetail);
    if(props.rowDetail != undefined){
      getPrcDetail(props.rowDetail.idx)
      // getCatDetail(props.rowDetail.crw_idx)
      // getCrwDetail(props.rowDetail.crw_idx)
      // getTrsDetail(props.rowDetail.crw_idx)
    }
  }, [props.rowDetail]);

  if(prc_data == undefined) {return <Paper sx={{width:"100%", overflow: "auto"}}><Box sx={{fontWeight:700, fontSize: "52px"}}>Loading ...</Box></Paper>}

  return (

    <Box>
      <Dialog fullScreen fullWidth={true} open={true}>
        <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
          <Box display="flex">
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>KHM. KM 데이터 확인 [{prc_data.idx}]</Box>
            <IconButton
              sx={{marginLeft: "auto", marginRight: "94px", backgroundColor: "#ff9494"}}
              edge="start"
              color="inherit"
              onClick={() => props.setDialogOpen(false)}
              aria-label="close"
            >
              <GridCloseIcon />
            </IconButton>
          </Box>
          <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
        </DialogTitle>
        <DialogContent dividers>
          <Paper sx={{width:"100%", overflow: "auto"}}>
            <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>데이터 정보</Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <Box>
              <Box sx={{position: "sticky",top: "-16px", zIndex: 1, backgroundColor:"#fff"}} >
                <Box display="flex">
                  <Box display="flex" sx={{marginLeft: "50px"}}>
                    <Box sx={{width:"100%"}}>

                      <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                        <Box sx={{fontSize:"12px",fontWeight:700, width:"40px"}}>idx</Box>
                        <Box sx={{fontSize:"12px", width:"80px"}}>{prc_data.idx}</Box>
                        <Box sx={{fontSize:"12px",fontWeight:700, width:"80px"}}>crw_idx</Box>
                        <Box sx={{fontSize:"12px", width:"130px"}}>{prc_data.crw_idx}</Box>
                        <Box sx={{fontSize:"12px",fontWeight:700, width:"80px"}}>mgm_pk</Box>
                        <Box sx={{fontSize:"12px", width:"200px"}}>{prc_data.mgm_pk}</Box>
                        <Box sx={{fontSize:"12px",fontWeight:700, width:"80px"}}>발행일자</Box>
                        <Box sx={{fontSize:"12px", width:"130px"}}>{prc_data.issue_date}</Box>
                      </Box>

                      <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                      <Box sx={{fontSize:"12px",fontWeight:700, width:"50px"}}>어절수</Box>
                      <Box sx={{fontSize:"12px", width:"80px"}}>{prc_data.wrd_cnt}</Box>
                        <Box sx={{fontSize:"12px",fontWeight:700, width:"80px"}}>자료유형</Box>
                        <Select id="data_type_cd" value={prc_data.data_type_cd || "01"} disabled sx={{color:"green",width:"126px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                          <MenuItem dense value={"01"}>저서</MenuItem>
                          <MenuItem dense value={"02"}>논문</MenuItem>
                          <MenuItem dense value={"03"}>기사</MenuItem>
                          <MenuItem dense value={"04"}>문서</MenuItem>
                          <MenuItem dense value={"05"}>직접작성</MenuItem>
                          <MenuItem dense value={"06"}>기타</MenuItem>
                        </Select>
                        <Box sx={{fontSize:"12px",fontWeight:700, width:"100px"}}>원본파일형태</Box>
                        <Box sx={{fontSize:"12px", width:"100px"}}>{prc_data.org_ext}</Box>
                        {/* {crwDetail && 
                          <>
                            <Box sx={{fontSize:"12px",fontWeight:700, width:"100px"}}>사이트명</Box>
                            <Box sx={{fontSize:"12px", width:"200px"}}>{crwDetail.site_name}</Box>
                          </>
                        } */}
                      </Box>

                      {prc_data.org_ext == 'HTML' && 
                      <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                        <Box sx={{fontSize:"12px",fontWeight:700, width:"100px"}}>데이터출처</Box>
                        <Box sx={{fontSize:"12px", width:"864px"}}>{prc_data.url}</Box>
                      </Box>
                      }

                      <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                        <Box sx={{fontSize:"12px",fontWeight:700, width:"172px"}}>저작자(한국어)</Box>
                        <Box sx={{fontSize:"12px", width:"282px"}}>{prc_data.writer_ko}</Box>
                        <Box sx={{fontSize:"12px",fontWeight:700, width:"204px"}}>저작자(크메르어)</Box>
                        <Box sx={{fontSize:"12px", width:"320px"}}>{prc_data.writer_km}</Box>
                      </Box>

                      <Box m={0.5} display="flex" sx={{alignItems:"center"}}>
                        <Box sx={{fontSize:"12px", fontWeight:700, width:"172px"}}>저작권소유자(한국어)</Box>
                        <Box sx={{fontSize:"12px", width:"266px"}}>
                        {prc_data.copyrighter_ko}
                          {/* <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                                    value={prc_data.copyrighter_ko || ""} onChange={(e) => {setPrc_data({ ...prc_data, copyrighter_ko: e.target.value });}}
                            InputProps={{
                              style: {width: "280px", height:"28px", fontSize:"12px"},
                              inputProps: { 
                                spellCheck: "false" // spellcheck를 false로 설정
                              },
                            }}
                          /> */}
                        </Box>
                        <Box sx={{marginLeft:"16px", fontSize:"12px", fontWeight:700, width:"204px"}}>저작권소유자(크메르어)</Box>
                        <Box sx={{fontSize:"12px", width:"320px"}}>
                        {prc_data.copyrighter_km}
                          {/* <TextField sx={{fontSize:"8px"}} id="url" name="url" size="small"
                                    value={prc_data.copyrighter_sw || ""} onChange={(e) => {setPrc_data({ ...prc_data, copyrighter_sw: e.target.value });}}
                            InputProps={{
                              style: {width: "320px", height:"28px", fontSize:"12px"},
                              inputProps: { 
                                spellCheck: "false" // spellcheck를 false로 설정
                              },
                            }}
                          /> */}
                        </Box>
                      </Box>
                      
                    </Box>
                  </Box>


                  <Box sx={{width:"100%"}}>
                    <Box display="flex" justifyContent="left" sx={{alignItems: "center", marginLeft:"16px"}}>
                      <Box sx={{fontWeight:700, width:"72px", fontSize:"12px"}}>부적합코드</Box>
                      <Select id="isp1_rsn_cd" value={prc_data.isp1_rsn_cd || "None"} onChange={(e) => {setPrc_data({ ...prc_data, isp1_rsn_cd: e.target.value });}} sx={{fontSize:"12px", height: "28px", fontWeight:700, textAlign:"center"}}>
                        <MenuItem dense value={"None"}>선택안함</MenuItem>
                        <MenuItem dense value={"01"}>01.캄보디아와 관련없는 내용</MenuItem>
                        <MenuItem dense value={"02"}>02.원문 품질 부적합</MenuItem>
                        <MenuItem dense value={"03"}>03.한국어/영어 부적합</MenuItem>
                        <MenuItem dense value={"04"}>04.한국어 부적합</MenuItem>
                        <MenuItem dense value={"05"}>05.영어 부적합</MenuItem>
                        <MenuItem dense value={"09"}>09.직접입력</MenuItem>
                      </Select>
                      <Button onClick={handleClick('right-start')}><HelpOutlineIcon/></Button>
                      <Popper
                        // Note: The following zIndex style is specifically for documentation purposes and may not be necessary in your application.
                        sx={{ zIndex: 1300}}
                        open={open_pop}
                        anchorEl={anchorEl}
                        placement={placement}
                        transition
                      >
                        {({ TransitionProps }) => (
                          <Fade {...TransitionProps} timeout={1}>
                            <Paper sx={{fontSize:"12px"}}>
                              <Box sx={{ p: 1 }}>01. <b style={{color:"blue"}}>캄보디아와 관련없는 내용</b> - 원문 전체가 캄보디아가 아닌 타 국가와 관련된 내용임</Box>
                              <Box sx={{ p: 1 }}>02. <b style={{color:"blue"}}>원문 품질 부적합</b> - 원문이 정상적이지 않은 경우 (특별한 내용없음, 광고, 정치적 성향 강조 … 등)</Box>
                              <Box sx={{ p: 1 }}>03. <b style={{color:"blue"}}>한국어/영어 부적합</b> - 한국어, 영어 둘다 수정할 수 없는 수준으로 잘못 번역되었음</Box>
                              <Box sx={{ p: 1 }}>04. <b style={{color:"blue"}}>한국어 부적합</b> - 한국어가 수정할 수 없는 수준으로 잘못 번역되었음</Box>
                              <Box sx={{ p: 1 }}>05. <b style={{color:"blue"}}>영어 부적합</b> - 영어가 수정할 수 없는 수준으로 잘못 번역되었음</Box>
                              <Box sx={{ p: 1 }}>09. <b style={{color:"blue"}}>직접입력</b> - 부적합 사유를 '검수비고(사유)'란에 직접 입력하였음</Box>
                            </Paper>
                          </Fade>
                        )}
                      </Popper>
                    </Box>
                    <Box display="flex" justifyContent="left" sx={{alignItems: "center", marginLeft:"16px"}}>
                      <Box sx={{fontWeight:700, width:"120px", fontSize:"18px"}}>검수비고(사유)</Box>
                      <Box sx={{marginLeft:"8px", fontSize:"16px", width:"400px"}}>
                        <textarea value={prc_data.isp1_rsn || ""} onChange={(e) => {setPrc_data({ ...prc_data, isp1_rsn: e.target.value });}} spellCheck="false" style={{width:"100%",minHeight:"32px", fontSize:"14px", fontWeight:600,padding:"2px"}}  />
                      </Box>
                    </Box>
                    <Box display="flex" sx={{marginRight: "90px"}}>
                    {prc_data && 
                      <Box display="flex" sx={{alignItems: "center"}}>
                        <Box sx={{marginLeft:"16px", fontSize:"14px", fontWeight:700}}>Instruction 대상</Box>
                        <Checkbox style={{ color: '#da33f0' }} checked={prc_data.instruction_yn == 'Y'? true : false} onClick={(e:any)=> {updateInstructionYn(prc_data.instruction_yn == 'Y'? false : true); }}></Checkbox>
                      </Box>
                    }
                      <Button variant="contained" color="secondary" sx={{fontSize:"20px", fontWeight:700, margin:"8px 16px 8px auto",width:"100px",height:"28px"}}
                        onClick={() => {
                          saveIsp1Data('R');
                        }}
                      >
                        반려
                      </Button>
                      <Button variant="contained" color="secondary" sx={{fontSize:"20px", fontWeight:700, margin:"8px 16px 8px auto",width:"100px",height:"28px"}}
                        onClick={() => {
                          saveIsp1Data('N');
                        }}
                      >
                        부적합
                      </Button>
                      <Button variant="contained" sx={{fontSize:"20px", fontWeight:700, margin:"8px 16px",width:"100px",height:"28px"}}
                        onClick={() => {
                          saveIsp1Data('Y');
                        }}
                      >
                        적합
                      </Button>
                    </Box>
                    
                  </Box>



                </Box>

              </Box>
              <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>

              
              
                <Box display="flex" justifyContent="center">
                  {/* {crwDetail ?  */}
                  <>
                  {l_select == "KM" && <Box>
                    <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#c7ffbb"}}>
                      <Box sx={{width:"520px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{display:"flex", alignItems:"center"}}>
                            <Box sx={{marginLeft:"4px"}}>
                              <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KM</Box> */}
                                <Select id="l_select" value={l_select || "KM"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                                    <MenuItem dense value={"KM"}>KM</MenuItem>
                                    <MenuItem dense value={"KO"}>KO</MenuItem>
                                    <MenuItem dense value={"EN"}>EN</MenuItem>
                                  </Select>
                                <Box sx={{marginLeft:"16px"}}>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                                  <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"380px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                                    <MenuItem dense value={"101"}><b style={{fontFamily: "Khmer OS, serif"}}>វប្បធម៌,សិល្បៈ,ការអប់រំ</b></MenuItem>
                                    <MenuItem dense value={"102"}><b style={{fontFamily: "Khmer OS, serif"}}>ប្រវត្តិសាស្រ្ត,ភូមិសាស្ត្រ,ទេសចរណ៍</b></MenuItem>
                                    <MenuItem dense value={"103"}><b style={{fontFamily: "Khmer OS, serif"}}>កីឡា,ផ្សេងៗ</b></MenuItem>
                                    <MenuItem dense value={"204"}><b style={{fontFamily: "Khmer OS, serif"}}>សង្គម,ឧស្សាហកម្ម</b></MenuItem>
                                    <MenuItem dense value={"205"}><b style={{fontFamily: "Khmer OS, serif"}}>នយោបាយ,សេដ្ឋកិច្ច</b></MenuItem>
                                    <MenuItem dense value={"206"}><b style={{fontFamily: "Khmer OS, serif"}}>វិទ្យាសាស្ត្រ,វេជ្ជសាស្ត្រ</b></MenuItem>
                                    <MenuItem dense value={"307"}><b style={{fontFamily: "Khmer OS, serif"}}>ទំនៀមទម្លាប,ទម្លាប់</b></MenuItem>
                                    <MenuItem dense value={"408"}><b style={{fontFamily: "Khmer OS, serif"}}>ជីវិតប្រចាំថ្ងៃ , អាហារ</b></MenuItem>
                                  </Select>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                                  <Box><textarea value={prc_data.kwd_km} onChange={(e) => {setPrc_data({ ...prc_data, kwd_km: e.target.value });}} spellCheck="false" style={{width:"386px",minHeight:"32px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>
                                </Box>
                              </Box>
                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                              <Box><textarea readOnly value={prc_data.title_km} spellCheck="false" style={{width:"510px",minHeight:"32px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>

                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                              <Box><textarea readOnly value={prc_data.text_km} spellCheck="false" style={{width:"510px",minHeight:"346px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>

                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>
                  }
                  {l_select == "KO" && <Box>
                    <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
                      <Box sx={{width:"520px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{display:"flex", alignItems:"center"}}>
                            <Box sx={{marginLeft:"4px"}}>
                              <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box> */}
                                <Select id="l_select" value={l_select || "KO"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                                    <MenuItem dense value={"KM"}>KM</MenuItem>
                                    <MenuItem dense value={"KO"}>KO</MenuItem>
                                    <MenuItem dense value={"EN"}>EN</MenuItem>
                                  </Select>
                                <Box sx={{marginLeft:"16px"}}>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                                  <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"380px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                                    <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
                                    <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
                                    <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
                                    <MenuItem dense value={"204"}>사회,산업</MenuItem>
                                    <MenuItem dense value={"205"}>정치,경제</MenuItem>
                                    <MenuItem dense value={"206"}>과학,의학</MenuItem>
                                    <MenuItem dense value={"307"}>관습,의례</MenuItem>
                                    <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
                                  </Select>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                                  <Box><textarea value={prc_data.kwd_ko || ""} onChange={(e) => {setPrc_data({ ...prc_data, kwd_ko: e.target.value });}} spellCheck="false" style={{width:"386px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                                </Box>
                              </Box>
                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                              <Box><textarea value={prc_data.title_ko || ""} onChange={(e) => {setPrc_data({ ...prc_data, title_ko: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                              <Box><textarea value={prc_data.text_ko || ""} onChange={(e) => {setPrc_data({ ...prc_data, text_ko: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"346px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>}
                  {l_select == "EN" && <Box>
                    <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#f1d4d9"}}>
                      <Box sx={{width:"520px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{display:"flex", alignItems:"center"}}>
                            <Box sx={{marginLeft:"4px"}}>
                              <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box> */}
                                <Select id="l_select" value={l_select || "EN"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                                    <MenuItem dense value={"KM"}>KM</MenuItem>
                                    <MenuItem dense value={"KO"}>KO</MenuItem>
                                    <MenuItem dense value={"EN"}>EN</MenuItem>
                                  </Select>
                                <Box sx={{marginLeft:"16px"}}>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                                  <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"380px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                                    <MenuItem dense value={"101"}>Culture,Arts,Education</MenuItem>
                                    <MenuItem dense value={"102"}>History,Geography,Tourism</MenuItem>
                                    <MenuItem dense value={"103"}>Sports,Other</MenuItem>
                                    <MenuItem dense value={"204"}>Society,Industry</MenuItem>
                                    <MenuItem dense value={"205"}>Politics,Economy</MenuItem>
                                    <MenuItem dense value={"206"}>Science,Medicine</MenuItem>
                                    <MenuItem dense value={"307"}>Custom,Ritual</MenuItem>
                                    <MenuItem dense value={"408"}>Daily Life,Food</MenuItem>
                                  </Select>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                                  <Box><textarea value={prc_data.kwd_en || ""} onChange={(e) => {setPrc_data({ ...prc_data, kwd_en: e.target.value });}} spellCheck="false" style={{width:"386px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                                </Box>
                              </Box>
                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                              <Box><textarea value={prc_data.title_en || ""} onChange={(e) => {setPrc_data({ ...prc_data, title_en: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                              <Box><textarea value={prc_data.text_en || ""} onChange={(e) => {setPrc_data({ ...prc_data, text_en: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"346px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>}
                  </>
                  {/*  :""} */}

                  {/* {trsDetail ?  */}
                  <>

                  {m_select == "KM" && <Box>
                    <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#c7ffbb"}}>
                      <Box sx={{width:"520px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{display:"flex", alignItems:"center"}}>
                            <Box sx={{marginLeft:"4px"}}>
                              <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KM</Box> */}
                                <Select id="m_select" value={m_select || "KM"} onChange={(e) => {setM_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                                    <MenuItem dense value={"KM"}>KM</MenuItem>
                                    <MenuItem dense value={"KO"}>KO</MenuItem>
                                    <MenuItem dense value={"EN"}>EN</MenuItem>
                                  </Select>
                                <Box sx={{marginLeft:"16px"}}>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                                  <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"380px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                                    <MenuItem dense value={"101"}><b style={{fontFamily: "Khmer OS, serif"}}>វប្បធម៌,សិល្បៈ,ការអប់រំ</b></MenuItem>
                                    <MenuItem dense value={"102"}><b style={{fontFamily: "Khmer OS, serif"}}>ប្រវត្តិសាស្រ្ត,ភូមិសាស្ត្រ,ទេសចរណ៍</b></MenuItem>
                                    <MenuItem dense value={"103"}><b style={{fontFamily: "Khmer OS, serif"}}>កីឡា,ផ្សេងៗ</b></MenuItem>
                                    <MenuItem dense value={"204"}><b style={{fontFamily: "Khmer OS, serif"}}>សង្គម,ឧស្សាហកម្ម</b></MenuItem>
                                    <MenuItem dense value={"205"}><b style={{fontFamily: "Khmer OS, serif"}}>នយោបាយ,សេដ្ឋកិច្ច</b></MenuItem>
                                    <MenuItem dense value={"206"}><b style={{fontFamily: "Khmer OS, serif"}}>វិទ្យាសាស្ត្រ,វេជ្ជសាស្ត្រ</b></MenuItem>
                                    <MenuItem dense value={"307"}><b style={{fontFamily: "Khmer OS, serif"}}>ទំនៀមទម្លាប,ទម្លាប់</b></MenuItem>
                                    <MenuItem dense value={"408"}><b style={{fontFamily: "Khmer OS, serif"}}>ជីវិតប្រចាំថ្ងៃ , អាហារ</b></MenuItem>
                                  </Select>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                                  <Box><textarea value={prc_data.kwd_km || ""} onChange={(e) => {setPrc_data({ ...prc_data, kwd_km: e.target.value });}} spellCheck="false" style={{width:"386px",minHeight:"32px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>
                                </Box>
                              </Box>
                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                              <Box><textarea readOnly value={prc_data.title_km || ""} spellCheck="false" style={{width:"510px",minHeight:"32px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>

                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                              <Box><textarea readOnly value={prc_data.text_km || ""} spellCheck="false" style={{width:"510px",minHeight:"346px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>

                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>
                  }
                  {m_select == "KO" && <Box>
                    <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
                      <Box sx={{width:"520px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{display:"flex", alignItems:"center"}}>
                            <Box sx={{marginLeft:"4px"}}>
                              <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box> */}
                                <Select id="m_select" value={m_select || "KO"} onChange={(e) => {setM_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                                    <MenuItem dense value={"KM"}>KM</MenuItem>
                                    <MenuItem dense value={"KO"}>KO</MenuItem>
                                    <MenuItem dense value={"EN"}>EN</MenuItem>
                                  </Select>
                                <Box sx={{marginLeft:"16px"}}>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                                  <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"380px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                                    <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
                                    <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
                                    <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
                                    <MenuItem dense value={"204"}>사회,산업</MenuItem>
                                    <MenuItem dense value={"205"}>정치,경제</MenuItem>
                                    <MenuItem dense value={"206"}>과학,의학</MenuItem>
                                    <MenuItem dense value={"307"}>관습,의례</MenuItem>
                                    <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
                                  </Select>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                                  <Box><textarea value={prc_data.kwd_ko || ""} onChange={(e) => {setPrc_data({ ...prc_data, kwd_ko: e.target.value });}} spellCheck="false" style={{width:"386px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                                </Box>
                              </Box>
                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                              <Box><textarea value={prc_data.title_ko || ""} onChange={(e) => {setPrc_data({ ...prc_data, title_ko: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                              <Box><textarea value={prc_data.text_ko || ""} onChange={(e) => {setPrc_data({ ...prc_data, text_ko: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"346px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>}
                  {m_select == "EN" && <Box>
                    <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#f1d4d9"}}>
                      <Box sx={{width:"520px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{display:"flex", alignItems:"center"}}>
                            <Box sx={{marginLeft:"4px"}}>
                              <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box> */}
                                <Select id="m_select" value={m_select || "EN"} onChange={(e) => {setM_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                                    <MenuItem dense value={"KM"}>KM</MenuItem>
                                    <MenuItem dense value={"KO"}>KO</MenuItem>
                                    <MenuItem dense value={"EN"}>EN</MenuItem>
                                  </Select>
                                <Box sx={{marginLeft:"16px"}}>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                                  <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"380px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                                    <MenuItem dense value={"101"}>Culture,Arts,Education</MenuItem>
                                    <MenuItem dense value={"102"}>History,Geography,Tourism</MenuItem>
                                    <MenuItem dense value={"103"}>Sports,Other</MenuItem>
                                    <MenuItem dense value={"204"}>Society,Industry</MenuItem>
                                    <MenuItem dense value={"205"}>Politics,Economy</MenuItem>
                                    <MenuItem dense value={"206"}>Science,Medicine</MenuItem>
                                    <MenuItem dense value={"307"}>Custom,Ritual</MenuItem>
                                    <MenuItem dense value={"408"}>Daily Life,Food</MenuItem>
                                  </Select>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                                  <Box><textarea value={prc_data.kwd_en || ""} onChange={(e) => {setPrc_data({ ...prc_data, kwd_en: e.target.value });}} spellCheck="false" style={{width:"386px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                                </Box>
                              </Box>
                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                              <Box><textarea value={prc_data.title_en || ""} onChange={(e) => {setPrc_data({ ...prc_data, title_en: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                              <Box><textarea value={prc_data.text_en || ""} onChange={(e) => {setPrc_data({ ...prc_data, text_en: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"346px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>}

                  {r_select == "KM" && <Box>
                    <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#c7ffbb"}}>
                      <Box sx={{width:"520px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{display:"flex", alignItems:"center"}}>
                            <Box sx={{marginLeft:"4px"}}>
                              <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KM</Box> */}
                                <Select id="r_select" value={r_select || "KM"} onChange={(e) => {setR_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                                    <MenuItem dense value={"KM"}>KM</MenuItem>
                                    <MenuItem dense value={"KO"}>KO</MenuItem>
                                    <MenuItem dense value={"EN"}>EN</MenuItem>
                                  </Select>
                                <Box sx={{marginLeft:"16px"}}>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                                  <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"380px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                                  <MenuItem dense value={"101"}><b style={{fontFamily: "Khmer OS, serif"}}>វប្បធម៌,សិល្បៈ,ការអប់រំ</b></MenuItem>
                                    <MenuItem dense value={"102"}><b style={{fontFamily: "Khmer OS, serif"}}>ប្រវត្តិសាស្រ្ត,ភូមិសាស្ត្រ,ទេសចរណ៍</b></MenuItem>
                                    <MenuItem dense value={"103"}><b style={{fontFamily: "Khmer OS, serif"}}>កីឡា,ផ្សេងៗ</b></MenuItem>
                                    <MenuItem dense value={"204"}><b style={{fontFamily: "Khmer OS, serif"}}>សង្គម,ឧស្សាហកម្ម</b></MenuItem>
                                    <MenuItem dense value={"205"}><b style={{fontFamily: "Khmer OS, serif"}}>នយោបាយ,សេដ្ឋកិច្ច</b></MenuItem>
                                    <MenuItem dense value={"206"}><b style={{fontFamily: "Khmer OS, serif"}}>វិទ្យាសាស្ត្រ,វេជ្ជសាស្ត្រ</b></MenuItem>
                                    <MenuItem dense value={"307"}><b style={{fontFamily: "Khmer OS, serif"}}>ទំនៀមទម្លាប,ទម្លាប់</b></MenuItem>
                                    <MenuItem dense value={"408"}><b style={{fontFamily: "Khmer OS, serif"}}>ជីវិតប្រចាំថ្ងៃ , អាហារ</b></MenuItem>
                                  </Select>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                                  <Box><textarea value={prc_data.kwd_km || ""} onChange={(e) => {setPrc_data({ ...prc_data, kwd_km: e.target.value });}} spellCheck="false" style={{width:"386px",minHeight:"32px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>
                                </Box>
                              </Box>
                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                              <Box><textarea readOnly value={prc_data.title_km || ""} spellCheck="false" style={{width:"510px",minHeight:"32px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>

                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                              <Box><textarea readOnly value={prc_data.text_km || ""} spellCheck="false" style={{width:"510px",minHeight:"346px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Khmer OS, serif"}}  /></Box>

                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>
                  }
                  {r_select == "KO" && <Box>
                    <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
                      <Box sx={{width:"520px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{display:"flex", alignItems:"center"}}>
                            <Box sx={{marginLeft:"4px"}}>
                              <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box> */}
                                <Select id="r_select" value={r_select || "KO"} onChange={(e) => {setR_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                                    <MenuItem dense value={"KM"}>KM</MenuItem>
                                    <MenuItem dense value={"KO"}>KO</MenuItem>
                                    <MenuItem dense value={"EN"}>EN</MenuItem>
                                  </Select>
                                <Box sx={{marginLeft:"16px"}}>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                                  <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"380px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                                    <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
                                    <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
                                    <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
                                    <MenuItem dense value={"204"}>사회,산업</MenuItem>
                                    <MenuItem dense value={"205"}>정치,경제</MenuItem>
                                    <MenuItem dense value={"206"}>과학,의학</MenuItem>
                                    <MenuItem dense value={"307"}>관습,의례</MenuItem>
                                    <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
                                  </Select>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                                  <Box><textarea value={prc_data.kwd_ko || ""} onChange={(e) => {setPrc_data({ ...prc_data, kwd_ko: e.target.value });}} spellCheck="false" style={{width:"386px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                                </Box>
                              </Box>
                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                              <Box><textarea value={prc_data.title_ko || ""} onChange={(e) => {setPrc_data({ ...prc_data, title_ko: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                              <Box><textarea value={prc_data.text_ko || ""} onChange={(e) => {setPrc_data({ ...prc_data, text_ko: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"346px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>}
                  {r_select == "EN" && <Box>
                    <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#f1d4d9"}}>
                      <Box sx={{width:"520px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                        <Box sx={{display:"flex", alignItems:"center"}}>
                          <Box sx={{display:"flex", alignItems:"center"}}>
                            <Box sx={{marginLeft:"4px"}}>
                              <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                                {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box> */}
                                <Select id="r_select" value={r_select || "EN"} onChange={(e) => {setR_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                                    <MenuItem dense value={"KM"}>KM</MenuItem>
                                    <MenuItem dense value={"KO"}>KO</MenuItem>
                                    <MenuItem dense value={"EN"}>EN</MenuItem>
                                  </Select>
                                <Box sx={{marginLeft:"16px"}}>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                                  <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"380px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                                    <MenuItem dense value={"101"}>Culture,Arts,Education</MenuItem>
                                    <MenuItem dense value={"102"}>History,Geography,Tourism</MenuItem>
                                    <MenuItem dense value={"103"}>Sports,Other</MenuItem>
                                    <MenuItem dense value={"204"}>Society,Industry</MenuItem>
                                    <MenuItem dense value={"205"}>Politics,Economy</MenuItem>
                                    <MenuItem dense value={"206"}>Science,Medicine</MenuItem>
                                    <MenuItem dense value={"307"}>Custom,Ritual</MenuItem>
                                    <MenuItem dense value={"408"}>Daily Life,Food</MenuItem>
                                  </Select>
                                  <Box sx={{margin:"0px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                                  <Box><textarea value={prc_data.kwd_en || ""} onChange={(e) => {setPrc_data({ ...prc_data, kwd_en: e.target.value });}} spellCheck="false" style={{width:"386px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                                </Box>
                              </Box>
                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                              <Box><textarea value={prc_data.title_en || ""} onChange={(e) => {setPrc_data({ ...prc_data, title_en: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"50px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                              <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                              <Box><textarea value={prc_data.text_en || ""} onChange={(e) => {setPrc_data({ ...prc_data, text_en: e.target.value });}} spellCheck="false" style={{width:"510px",minHeight:"346px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>

                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Box>}
                
                </>
              {/* : ""} */}
              {prc_data.prc_yn == "Y" &&
              <Button variant="contained" size="small" sx={{fontWeight:700, margin:"8px 16px 8px 16px", height:"100px", backgroundColor:"#e79055"}} onClick={() => setOpenJsonDialog(true)}>
                OPEN JSON
              </Button>
              }
              {openJsonDialog ? <GncJsonDialog gub={"KHM"} idx={prc_data.idx} setOpenJsonDialog={setOpenJsonDialog} />:<></>}
              
              </Box>

            </Box>


            
            
          </Paper>
        {/* <DialogActions>
            <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                props.setDialogOpen(false);
              }}
            >
              CANCEL
            </Button>
            <Button variant="contained" sx={{fontWeight:700, margin:"8px 16px"}}
              onClick={() => {
                saveMmmuData();
              }}
            >
              SAVE
            </Button>
          </DialogActions> */}

        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default KhmISPTransDialog;
